@if(loading){
<div class="as-spinner-green as-loader-centered">
  <mat-spinner [diameter]="40"></mat-spinner>
</div>
}@else{
<div class="as-detail-img">
  <div class="as-detail-discount" *ngIf="product?.discount">
    <mat-label class="as-font as-font-white as-font-13">{{
      product?.discount
    }}</mat-label>
  </div>
  <a [routerLink]="product.product_url">
    <img
      [defaultImage]="defaultImage"
      [lazyLoad]="imgHa"
      class="as-pointer"
      onerror="this.src='assets/images/default-product.svg';"
      alt="Producto img"
    />
  </a>
</div>
<div class="as-product-name">
  <a
    [routerLink]="product.product_url"
    class="as-pointer as-font as-font-13 as-font-black-gray"
  >
    {{ product?.description | slice : 0 : 36
    }}{{ product.description?.length > 36 ? '...' : '' }}</a
  >
  <mat-label class="as-font as-font-10 as-font-grey-7e">{{
    product?.equivalence
  }}</mat-label>
  <div class="as-price-container">
    <mat-label class="as-font-grey-88 as-font-14 as-font-normal">
      {{ historicalQuantity }}
      {{
        product.unit === 'grammage' || product.unit === 'granel' ? 'gr' : 'pz'
      }}
      -
      {{ historicalPrice | currency : '$' }}
    </mat-label>
  </div>
</div>
<mat-icon
  (click)="
    !product.showHeart
      ? addProductToFavouriteList()
      : openSureDeleteProductFromList()
  "
  svgIcon="{{ !product.showHeart ? 'ic-heart-off' : 'ic-heart-on' }}"
  class="as-pointer as-icon-heart"
>
</mat-icon>
<div class="as-details-container">
  <div class="as-right-content">
    <div>
      <button
        *ngIf="product?.stock > 0 && !addingProduct && !productAdded"
        style="width: 170px; height: 37px; border: 1px solid #6eb24c"
        mat-stroked-button
        [ngClass]="[
          'as-border-green',
          !displayProductQuantity ? 'mt-27' : 'mt-16'
        ]"
        class="as-product-add"
        color="accent"
        (click)="displayDetailsBeforeAdding()"
      >
        <mat-label
          class="as-font as-font-semibold as-font-14 as-open-sans as-font-green-6e"
        >
          {{ 'GENERAL.add' | translate }}
        </mat-label>
      </button>
      <div
        class="as-spinner-green as-row as-justify-center as-spinner-width"
        *ngIf="addingProduct"
      >
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
      <button
        *ngIf="
          (product?.stock === null ||
            product?.stock === undefined ||
            product?.stock <= 0) &&
          !addingProduct
        "
        mat-stroked-button
        style="width: 170px; height: 37px"
        [ngClass]="!displayProductQuantity ? 'mt-27' : 'mt-16'"
        class="as-product-unavailable"
        [disabled]="true"
      >
        <mat-label class="as-font">
          {{ 'PURCHASE.off' | translate }}
        </mat-label>
      </button>
    </div>
  </div>

  <div class="as-display-details">
    <div class="as-quantity-container">
      <div class="as-display-details" *ngIf="productAdded">
        <div class="as-options-container">
          <mat-select
            *ngIf="madurityList.length > 0"
            placeholder="{{ 'GENERAL.selectMadurity' | translate }}"
            [formControl]="madurity"
            (selectionChange)="setProductQuantity()"
          >
            <mat-option
              value="{{ option }}"
              *ngFor="let option of madurityList"
              >{{ option }}</mat-option
            >
          </mat-select>

          <mat-select
            *ngIf="sliceList.length > 0"
            [formControl]="slice"
            placeholder="Rebanada"
          >
            <mat-option *ngFor="let item of sliceList" [value]="item">
              {{ item }}</mat-option
            >
          </mat-select>
        </div>

        <div class="as-quantity-details">
          <div class="as-quantity-container">
            <ng-container *ngIf="productTypeQuantity === 'pza'; else grams">
              <div class="as-quantity">
                <button mat-button color="accent" (click)="subtract()">
                  <mat-icon svgIcon="ic-minus"></mat-icon>
                </button>
                <div class="input-value">
                  <input
                    mask="000000"
                    suffix=" pz"
                    (blur)="changePieces(productQuantity)"
                    [(ngModel)]="productQuantity"
                    type="text"
                    readonly
                  />
                </div>
                <button
                  [disabled]="
                    ((madurityList.length > 0 || sliceList.length > 0) &&
                      !madurity.value &&
                      !slice.value) ||
                    (productType === 'pza' &&
                      product?.stock <= productQuantity) ||
                    (productType === 'pza-grammage' &&
                      product?.stock <= productQuantity * product?.weight)
                  "
                  mat-button
                  color="accent"
                  (click)="add()"
                >
                  <mat-icon svgIcon="ic-plus"></mat-icon>
                </button>
              </div>
            </ng-container>
            <ng-template #grams>
              <div class="as-quantity">
                <button mat-button color="accent" (click)="subtract()">
                  <mat-icon svgIcon="ic-minus"></mat-icon>
                </button>
                <div class="input-value">
                  <input
                    mask="000000"
                    suffix=" gr"
                    (blur)="changeGrams(productQuantityGrams)"
                    [(ngModel)]="productQuantityGrams"
                    type="text"
                    readonly
                  />
                </div>
                <button
                  [disabled]="
                    ((madurityList.length > 0 || sliceList.length > 0) &&
                      !madurity.value &&
                      !slice.value) ||
                    product?.stock <= productQuantityGrams / 1000
                  "
                  mat-button
                  color="accent"
                  (click)="add()"
                >
                  <mat-icon svgIcon="ic-plus"></mat-icon>
                </button>
              </div>
            </ng-template>
          </div>
          <div
            class="as-switch-quantity as-mb-1em"
            *ngIf="productType === 'pza-grammage'"
          >
            <button
              mat-flat-button
              class="as-type-select pieces"
              [class.as-active]="productTypeQuantity === 'pza'"
              (click)="onSwitchTypeQuanity('pza')"
            >
              <mat-label class="as-font-12 as-font-bold">
                {{ 'GENERAL.pieces' | translate }}
              </mat-label>
            </button>
            <button
              mat-flat-button
              class="as-type-select grams"
              [class.as-active]="productTypeQuantity === 'grammage'"
              (click)="onSwitchTypeQuanity('grammage')"
            >
              <mat-label class="as-font-12 as-font-bold">
                {{ 'GENERAL.grams' | translate }}
              </mat-label>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
